import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './Toggle.scss';

class Toggle extends React.Component {
    state = {
        on: this.props.on,
    }

    componentDidUpdate(prevProps) {
        const {
            on,
        } = this.props;

        if (prevProps.on !== on) {
            this.setState(() => ({
                on,
            }));
        }
    }

    _onChange = () => {
        const {
            onChange,
            disabled,
            delayChange,
        } = this.props;
        if (!delayChange && !disabled) return onChange(!this.state.on);
        if (!disabled) {
            this.setState((state) => ({
                on: !state.on,
            }), () => {
                setTimeout(() => {
                    onChange(this.state.on);
                }, 0);
            });
        }
    }

    render() {
        const {
            disabled,
            id,
            className,
            labelText,
        } = this.props;
        const {
            on,
        } = this.state;
        return (
            <span className={styles.toggleRow}>
                <label className={classNames(styles.toggle, className)}>
                    <input
                        checked={on}
                        className={styles.input}
                        disabled={disabled}
                        onChange={this._onChange}
                        type="checkbox"
                        aria-hidden
                        readOnly
                    />
                    <span
                        aria-checked={on}
                        className={styles.slider}
                        id={`${id}-span`}
                        role="switch"
                    />
                </label>
                <label className={'label'} htmlFor={id} onClick={this._onChange}>
                    {labelText}
                </label>
            </span>
        );
    }
}

Toggle.propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    on: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    delayChange: PropTypes.bool,
};

Toggle.defaultProps = {
    on: true,
    onChange() {},
    disabled: false,
    delayChange: false,
};

export default Toggle;
